export default () => {
    const shouldLog = process.env.NODE_ENV !== 'test';

    if (shouldLog) {
        console.info('InMemory error tracker initialised');
    }

    return {
        setUser: (id = null, email = null) => {
            if (!id && !email) {
                return;
            }

            if (shouldLog) {
                console.log('ErrorTracker set user: ', id, email);
            }
        },

        setAccount: (accountId) => {
            if (shouldLog) {
                console.log('ErrorTracker set account: ', accountId);
            }
        },

        setExtraContext: () => {
            
        },

        /**
         * @param err {Error} Exception to capture
         * 
         * @return void
         */
        captureException: (err) => {
            if (!err instanceof Error) {
                return;
            }

            if (shouldLog) {
                console.log('ErrorTracker captured error: ', err);
            }
        },

        /**
         * @param message {string} message to capture
         * 
         * @return void
         */
        captureMessage: (message) => {
            if (typeof message !== 'string') {
                return;
            }

            if (shouldLog) {
                console.log('ErrorTracker captured message: ', message);
            }
        },
    }
};
